module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("CHAPTER "), _c('span', {
    staticClass: "big"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/ch.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chtitleb"
  }, [_vm._v("Nathan M. Muzzy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Morse lost no time in manufacturing and marketing his inventions, even as he continued to perfect the design (see color "), _c('span', {
    attrs: {
      "href": "#/Text/20_Chapter13#pla3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("plate 3")]), _vm._v("). His younger brother, Isaac, was a respected Massachusetts attorney when he wrote in 1870 that Morse deemed his new invention of great value and “immediately started North to try and get aid in its manufacture and introduction” in early 1857."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_1",
      "id": "fn3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Only a year after his first patent was granted in October 1856, Morse was making the cartridge and preparing to produce the firearm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the U.S. Congress and European powers began to recognize the potential military advantages of breech-loading firearms in the 1850s. Acknowledging the shortcomings of thousands of smoothbore muskets and obsolete rifles in the U.S. inventory, Congress hoped to convert some of them to breechloaders, thus salvaging some of its older firearms for ongoing use."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_2",
      "id": "fn3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Congress appropriated $90,000 on August 5, 1854, “for the purchase in the opinion of the Secretary of War, [of] the best breech loading rifles for the use of the U.S. Army: Provided that the Secretary of War, after a fair practical test thereof shall deem the purchase advisable and proper.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_3",
      "id": "fn3_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The purpose of the measure was to stimulate inventors to develop effective models of breechloaders, and it worked. Brigadier General Stephen Vincent Benet wrote, “it is here properly that the era of breechloaders in this country begins.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_4",
      "id": "fn3_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" A board of officers met at the Washington Arsenal in December 1854 to consider purchasing the most effective existing breechloader designs for further field-testing, but Secretary of War Jefferson Davis ordered the board to consider only carbines for use by the cavalry. Morse did not present a firearm for this trial because he had not yet made his first prototype.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse wrote in September 1870 that he spoke with Secretary Davis in late 1856 or early 1857. Morse showed Davis his recently completed firearm and cartridges, certainly a Searles-built gun, and requested that Davis order its testing for military use. Davis, “like all military officers” in Morse’s opinion, was opposed to breech-loading guns and offered him no encouragement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_5",
      "id": "fn3_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Davis favored muzzle loaders over existing breechloaders for infantry use and expended very little of the designated funds for breechloader development during his tenure. When Davis resigned from the War Office in March 1857, $82,143.50 of the original $90,000 fund remained unspent. Morse was confident in believing that his gun was a world-changing invention. He did not allow the disappointing meeting with "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Davis to deter him, and he decided to attack the problem along two simultaneous tracks. One was to persist in his pursuit of a military contract with the new secretary of war, John B. Floyd, who officially took over from Davis on March 6, 1857. The other path was to produce a sporting version of his firearm and sell it on the civilian market in hopes that he could attract general acceptance of the design.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("This firearm is serial number 60 of 100, part of a cased set made by Nathan M. Muzzy of Worcester, Massachusetts, in 1857 or 1858. The breech mechanism is a combination of Morse’s US Patent 15995 and British Patent 1357. Courtesy of Museum and Library of Confederate History, Greenville, S.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd, a graduate of South Carolina College and former governor of Virginia, held strong Southern sympathies and would become a Confederate brigadier general. He favored research involving breechloaders and began an active program to examine various "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("breech-loading designs. Floyd became so supportive of Morse’s work in the late 1850s that the U.S. Court of Claims referred to Floyd as Morse’s “special friend” in one of Morse’s postwar lawsuits against the United States."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_6",
      "id": "fn3_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg32_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("A close-up view of the engravings seen on Nathan Muzzy’s cased sets, Muzzy & Co. Worcester. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg32_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("A close-up view of the rear sight and threaded barrel on Nathan Muzzy’s cased sets. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within days of Floyd taking office, Morse presented a Searles-built firearm to the Ordnance Office and met with success. Morse recalled many years later, incorrectly, that it was one of Nathan Muzzy’s best firearms that he took to Floyd’s office in March. Muzzy, a gunsmith working in Worcester, Massachusetts, would begin manufacturing one hundred of Morse’s firearms by year’s end but as of early 1857 had not yet begun to do so. Floyd was highly impressed with Morse’s gun and probably instructed the chief of ordnance, Colonel Henry Knox Craig, to assess it. Craig complied when he wrote to William H. Bell, major of ordnance and commanding officer at the U.S. Arsenal at Washington, D.C., on March 5, “Mr. Morse, of Louisiana, will present at the arsenal a breech-loading rifle, which please cause to be tried, and report the result to this office, with your opinion as to the fitness of the arm for military service.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_7",
      "id": "fn3_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse presented a .54 caliber rifle with a thirty-inch, threaded barrel for testing, and he testified in 1877 that it was the Searles-built rifle that was used for this test."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_8",
      "id": "fn3_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Bell test-fired forty rounds from Morse’s firearm on March 6 and issued a favorable critique the same day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_9",
      "id": "fn3_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" He described the gun in detail and reported that it performed exceedingly well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_10",
      "id": "fn3_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Bell wrote, “This arm, though complicated in its machinery, is amazingly ingenious and very durable in its construction. It is worthy of the consideration of the department, and were it not for its complicated machinery, it would probably be as well suited to military as it certainly is to civil purposes.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_11",
      "id": "fn3_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("Captain D. N. Ingraham, chief of the Bureau of Ordnance and Hydrography at the Washington Navy Yard, also ordered an evaluation of Morse’s invention. Commander John A. Dahlgren test-fired a Searles-built firearm with both a rifle barrel and a carbine barrel on March 14, 1857, at the Navy Yard, paying special attention to exposure to water."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_12",
      "id": "fn3_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Morse testified in 1877 that it was the same Searles-built rifle that Bell had tested a week earlier, confirming that the Searles-built gun had interchangeable, threaded barrels."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_13",
      "id": "fn3_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" In one of Dahlgren’s tests, an assistant poured water over the lock and breech as Morse fired the weapon, and there were no failures. In another test, cartridges were coated with shellac and grease, then submerged in water for forty-four hours, after which they were test-fired. Seven of twenty-five cartridges failed to fire. The powder in the cartridges was found to be dry, and the problem was determined to be from a lack of powder in the caps. In a third experiment, the loaded firearm was completely immersed in water and successfully fired on all five attempts. Dahlgren’s favorable report to Ingraham issued on March 17 stated that “the apparatus performs its functions perfectly and without fail,” and he recommended that it was worthy of a trial in service by a group of picked men."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_14",
      "id": "fn3_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In 1876 the U.S. Congress considered Dahlgren’s report to be an argument that Morse was due some remuneration for his services to the country."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_15",
      "id": "fn3_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" And in 1883 the chief of ordnance, Brigadier General S. V. Benet, acknowledged that this was the first evidence of such a center-fire, metallic cartridge in the U.S. Ordnance Department."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_16",
      "id": "fn3_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Floyd was impressed with both reports but did not immediately offer Morse a contract. Floyd, who was already a supporter of breechloader research and would soon be an advocate of Morse’s designs, wrote prophetically: “I think it may be fairly asserted now, that the highest efficiency of a body of men with fire-arms can only be secured by putting in their hands the best breech-loading arm. The long habit of using muzzle-loading arms will resist what seems to be so great an innovation, and ignorance may condemn; but as certainly as the percussion cap has superseded the flint and steel, so surely will the breech-loading gun drive out of use those that load at the muzzle. For cavalry, the revolver and breech-loader will supersede the saber.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_17",
      "id": "fn3_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After gaining a favorable assessment but no contract from Floyd in early 1857, Morse approached a Worcester, Massachusetts, gunsmith named Nathan Mills Muzzy to help him develop a civilian sporting version of his invention as a practical demonstration of its utility. Muzzy, born on June 14, 1822, in Worcester, was a blacksmith and armorer there from the mid-1840s into the 1850s. Dexter Hitchcock, born about 1826, was a rifle maker in Worcester by 1851. About 1855, he and Muzzy employed sixteen workers and formed a company called “Hitchcock and Muzzy” in Worcester."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_18",
      "id": "fn3_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" The company manufactured guns and ammunition in the Merrifield Building, which burned in 1854 but was rebuilt by 1856.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morse testified in 1877 that he left Louisiana to attend the breechloader trials at West Point, which were held in August 1857, and that he used a Searles-built gun in the trials."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_19",
      "id": "fn3_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Morse also made a visit or two to Worcester in the summer of 1857 and signed papers for his patent attorney there on both July 14 and September 7."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_20",
      "id": "fn3_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Certainly he was there to discuss business arrangements with Muzzy for the manufacture of his new breechloader and cartridges. They agreed that Muzzy would produce one hundred three-barrel cased sets of Morse’s firearm to be sold to the public."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_21",
      "id": "fn3_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other than those made by Searles in Baton Rouge, Muzzy and Company produced "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("the earliest Morse cartridges. Most likely, Muzzy made cartridges for Morse to use with the Searles-built gun in the 1857 West Point trials before he started making the firearm itself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_22",
      "id": "fn3_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Robert M. Holter described the early production of Morse’s cartridge case: “At first such cases were cast of bronze or copper and among the early military shipments were cartridge cases and molds for casting them. Inspection of the cartridge cases in my old oak gun box suggests that at least some were cast. At an unspecified date, but probably as early as 1858, Morse cartridge cases of drawn brass began to appear.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_23",
      "id": "fn3_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitchcock, Muzzy & Co. ceased to exist sometime in 1857, but Muzzy started his own company about that time called “Messrs. Muzzy and Co. Worcester, Massachusetts.” Morse wrote in 1870 that he paid Muzzy a large sum of money, “the larger part of $15,000” to manufacture one hundred of his sporting arms. The retail price was probably $125, that being the amount the U.S. government reimbursed Morse for the use of one such gun on the Utah Expedition in April 1858.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though we do not know exactly when Muzzy built his first Morse firearm, we do know that Morse used a Searles-built gun for the military trials held at West Point in August and September 1857, and he did show the board a new version of his gun—possibly built by Muzzy—on September 17, as well as an improved cartridge, but it was too late to enter the new gun in the competition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_24",
      "id": "fn3_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" We also know that Morse showed a Muzzy-built version to Floyd in November 1857. Muzzy was still producing Morse’s design at the same time that Morse was attempting to interest the U.S. government in utilizing his inventions for military purposes in 1858. Hicks writes, “As soon as the license was granted [two thousand alterations for five dollars each on September 9, 1858] Morse went to Worcester, Mass., and had the altered arms that were before the Board at West Point sent to him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_25",
      "id": "fn3_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Thus it appears that Muzzy began to manufacture Morse’s firearm in the latter half of 1857 and continued well into 1858.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Muzzy venture was a financial failure. Morse wrote, “When the first hundred arms were turned out, they did not find ready sale, and the company soon failed, and I lost all of my money except for $4,000, besides all my time.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_26",
      "id": "fn3_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Morse wrote in 1870 that it took about a year for Muzzy to manufacture a hundred firearms, “and it was found when they were completed, that they were so inferior in workmanship, that parties who had given me orders for them would not accept them, and in point of fact, I did not wish them to go out, fearing that their failure would injure the value of my patents.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_27",
      "id": "fn3_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Morse also wrote in 1870 that, after Muzzy’s company failed, he (Morse) put his own money into creating a new company called the Muzzy Rifle Barrel Manufacturing Company, also known as the Muzzy Rifle and Gun Manufacturing Company, and “Muzzy & Co, Rifle Barrels etc.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_28",
      "id": "fn3_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" The company existed until at least 1860, about which time it also failed, and Muzzy and Morse parted ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Muzzy-built Morse firearms incorporated elements of both Morse’s U.S. Patent 15995 and his British patent. The Muzzy was sold as a cased-set sporting arm, not a military weapon. Survivors include both complete cased sets and remnants. Each set consisted of one buttstock/receiver and three threaded, interchangeable barrels—a carbine, a rifle, and a shotgun. Reloadable cartridge cases, loading tools, and printed instructions were also included. The tools that accompanied the cased set were bullet molds for the rifle and carbine, two punches to make the base wads—one for making the wad itself and the other, which fit inside the first, for punching a hole in the wad for the percussion cap, "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("and a bullet seater for placing the projectile into the cartridge. The instructions reveal how Morse perceived the use of his new design:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DIRECTIONS FOR USING MORSE’S GUN")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Grasping, with the left hand, the stock, loosen the catches by pressure of the right forefinger and thumb, and bring the gun to full cock by lifting the cap piece. Attach the barrel by screwing it until the shoulder is brought up to the stock so that when the cap piece is shut down, the hooks will fall into the notches cut into the end of the barrel. The set screw on the underside must then, with a screwdriver, be tightened up; so that it will enter the side of the barrel and, thus, hold it in firm position. Open the small hinged door under the frame of the stock; so that the cock can come forward to the firing pin; and the gun is ready for use.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Tools that accompany Morse-designed, Nathan Muzzy–built cased sets. From Wray-Morse File 047. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg35_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Muzzy tools, including .55 caliber bullet mold with iron collar, funnel-sprue-cutter, and swedge. From Wray-Morse File 047. Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Top view of the Muzzy mold with the sprue cutter in place ready to receive molten lead. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg36_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Side view of the Muzzy mold. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg36_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("View of the Muzzy mold with the sprue device positioned to insert into the mold. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Muzzy bullet seater. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg37_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("These two punches were used to make base wads for Morse cartridges. “B” was used first to cut out the wad from a sheet of india rubber; then “A” was inserted into “B” and used to punch a center hole in the wad for the primer. Courtesy of Robert M. Holter.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('i', [_vm._v("Charging the Cases with Balls")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The balls being properly swedged insert the open cartridge case up to the head of the loading tool, at the opposite end of which, insert the ball, which is to be forced by the rammer, deep enough to retain it firmly while it is being greased then remove the cartridge from the loading tool, and, with hard tallow, or a candle, run lengthwise the ball until its circular rings are filled with the tallow. The required number of balls having been thus prepared, must be put back, one after another, into the loading tool, and should all be driven down by a small hammer or mallet into the cases, a little beyond the foremost ring of the ball, except when an unusual charge of powder is to be used; for which due allowance must be made.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('i', [_vm._v("Charging the Cases with Powder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Coarse common powder is preferable to rifle powder and must be accurately weighed or measured, and the charges may consist, at the discretion and experience of the shooter, of from thirty to sixty grains. It has been ascertained, however, by careful experiment, that forty grains of United States musket powder are enough for the carbine as well as for the rifle; forty-five or fifty grains may however be better for the rifle. The charge having been determined on, the powder is to be poured into the case at its larger end, and is to be pressed down by an india rubber wad, until the percussion cap in its centre so rests on the wires in the case so as to prevent any powder getting between the end of the wires and the fulminate in the cap. When this is properly done, the surface of the wad will be about one sixteenth of an inch below the rim of the case."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_29",
      "id": "fn3_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('i', [_vm._v("To charge with shot")]), _vm._v(", the armed rubber wad is, first, inserted; the powder, forty-five or fifty grains, is the poured into the opposite end and kept down by a wad; the shot are then added; and a wad covering the whole. On this outer wad should be marked the number of shot within, so that the hunter can promptly select the charge most proper for the game he is in quest of.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('i', [_vm._v("Percussion Caps")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Eley’s double waterproof central fire percussion caps are best adapted to Morse’s gun; but almost any cap will answer, if it is exactly fitted to the hole in the india rubber wad; and in all cases unvarnished caps are preferable. Hicks’s musket caps are very suitable; but care must be taken that the india rubber selected for wads should be rigid enough to prevent the cap from splitting too much.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('i', [_vm._v("Wadding")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("India rubber is the best material, and of the kind used for packing steam joints. Rubber belting and rubber cloth are suitable, but unmixed soft rubber ought never to be used unless sustained by a corresponding piece of hard leather. By this mode old india rubber shoes have been made available for hunting purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The entire wad, whether of packing or belt rubber, or of combined rubber and leather, ought to be about a quarter of an inch in thickness. In a wad composed of rubber and leather, pasteboard, &etc., the percussion cap should be thrust through the central hole "), _c('i', [_vm._v("from the rubber side")]), _vm._v(", and it must be placed in the cartridge case with the rubber side touching the powder.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('i', [_vm._v("Loading and Firing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The gun being in the left hand, the knobs on the cap piece are grasped with the right thumb and finger, and, at the same time, the cap piece is lifted and pulled back until the piece is at full cock. The cartridge is then inserted, and the cap piece is forced down to its place. If the gun, thus loaded, is not to be immediately fired, the hammer can be let down in the usual way; but if otherwise, the shooter will bring the gun to his shoulder, and, as he grasps the handle of the stock, the second finger of his right hand rests behind the guard and upon the safety catch, which he will move involuntarily, as he touches the trigger.")]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg38_1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("“Directions for Taking This Gun Apart.” Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pg39.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("“Directions for Using Morse’s Gun.” Courtesy of Atlanta History Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("These Guns are manufactured by Messrs. Muzzy & Co., Worcester, Massachusetts, who will, on application by mail, supply all the tools, implements, ammunition necessary for the shooter, whose address is accessible by means of the various express companies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_30",
      "id": "fn3_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Though the basic design of Muzzy-built receivers is identical, significant variations exist among surviving cased sets. Some have elaborate engraving on the side of the receiver, and others do not. The threads of one privately owned Muzzy barrel do not fit a receiver made for another Muzzy cased set."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_31",
      "id": "fn3_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" The caliber of the various barrels varies widely. The Atlanta History Center has two Muzzy cased sets, an early serial number, 7, and a late serial number, 94. Both have a .69 caliber (16-gauge) shotgun, a .48 caliber rifle, and a .52 caliber carbine. Another survivor, serial number 46, has a .69 caliber (16-gauge) shotgun, a .48 caliber rifle, and a .54 caliber carbine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_32",
      "id": "fn3_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" This weapon has a trigger guard, buttplate and sights made of iron, and a walnut stock. Lewis described variations among the Muzzy-built Morse firearms, a habit that was typical of Morse, who was constantly altering and improving his designs but not always seeking patents to cover the changes. Lewis wrote that the first of the cased sets came with a .54 caliber carbine, .50 caliber rifle, and 16 gauge (.69 caliber) shotgun. His article shows a photograph of a cased set with a .55 caliber carbine, a .55 caliber rifle, and a 12-gauge shotgun."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes#rfn3_33",
      "id": "fn3_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Serial number 60, on display at the Museum and Library of Confederate History in Greenville, South Carolina, has a 16-gauge shotgun and .54 caliber rifle and carbine barrels. Lewis further described a variation in the cartridges that came with the Muzzy cased sets. He wrote that a different-size rubber washer was used for each caliber, though all had the same rim diameter to fit the extractor. Also, Lewis wrote that the 16-gauge rim was too weak to withstand the extraction process and was reinforced by the addition of a steel ring, which then fit the .54 caliber–size rubber washer. Lewis did not cite his references, and his statement appears to disagree with Muzzy’s “Directions for Using Morse’s Gun,” which enclosed a single punch for making all three sizes of india rubber wads.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718902d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/10_Chapter03.vue
// module id = 84
// module chunks = 0